import ClipView from './ClipView';

import './clip-view.css';
import '../reset.css';


export default ClipView;
